// Module
var code = "<div class=\"cursor__circle\"></div> ";
// Exports
export default code;